// Chave do <div id="main"> no App.vue: muda quando a view muda ou quando os params mudam, para a view
// remontar e buscar de novo (ex.: /apps/106 -> /apps/506 reaproveitaria o componente com os dados do
// app anterior). Query fica de fora: ?tab= e ?homologation= nao trocam o recurso.
export function routeKey (route) {
  const base = route.matched[0]?.path ?? route.path
  const params = Object.keys(route.params ?? {}).sort().map(key => `${key}=${route.params[key]}`)

  return params.length ? `${base}?${params.join('&')}` : base
}
